import { observer } from 'mobx-react';
import { useId } from 'react';
import { Button, Disclosure, DisclosurePanel } from 'react-aria-components/Disclosure';
import { DisclosureGroup } from 'react-aria-components/DisclosureGroup';

import Icon from '../../../../app/shared/components/Icon/Icon';
import CheckboxGroup from './CheckboxGroup/CheckboxGroup';
import NumberRangePicker from './NumberRangePicker/NumberRangePicker';
import css from './ProductListingFilters.css';
import { BooleanFilter, FilterState, PriceRangeFilter, ProductListingFiltersState } from './ProductListingFiltersState';

interface ProductListingFiltersProps {
  state: ProductListingFiltersState;
  hidden?: boolean;
}

const ProductListingFilters = observer(({ state, hidden }: ProductListingFiltersProps) => {
  const headingId = useId();

  return (
    // TODO: Add a skip link to filters (only when filters are visible)
    <section className={css.root} aria-labelledby={headingId} hidden={hidden}>
      <h2 id={headingId} className={css.heading}>
        {state.translation.heading}
      </h2>
      <DisclosureGroup
        allowsMultipleExpanded
        expandedKeys={state.expansion.expandedIds}
        onExpandedChange={(keys) => state.expansion.setExpanded([...keys].map((key) => String(key)))}
      >
        {state.filters.map((filter) => (
          <Disclosure id={filter.id} className={css.disclosure} key={filter.id}>
            <h3>
              <Button slot="trigger" className={css.disclosureTrigger}>
                {filter.translation.label}
                <Icon className={css.icon} name="angleDown" />
              </Button>
            </h3>
            <DisclosurePanel className={css.disclosurePanel}>
              <Filter state={filter} />
            </DisclosurePanel>
          </Disclosure>
        ))}
      </DisclosureGroup>
    </section>
  );
});

export default ProductListingFilters;

interface FilterProps {
  state: FilterState;
}

const Filter = observer(({ state }: FilterProps) => {
  if (state instanceof BooleanFilter) {
    return <CheckboxGroup className={css.checkboxGroup} state={state.input} label={state.translation.label} />;
  }

  if (state instanceof PriceRangeFilter) {
    return (
      <NumberRangePicker state={state.range} translation={state.translation.range} label={state.translation.label} />
    );
  }

  return null;
});
